
import React from 'react'
import Nav from './Nav'
import { 
  ArrowLeft,
  Box,
  CreditCard,
  List,
  Settings,
  UserPlus,
  Users,
  File,
} from 'react-feather'

/**
 * TeamNavigation component.
 */

export default function TeamNavigation({ back }) {
  return <Nav>
    {back && <Nav.Item icon={ArrowLeft} to={`/`} title="Back to application menu">Back</Nav.Item>}
    <Nav.Item icon={Users} to={`/teams`} title="Manage teams">Teams</Nav.Item>
    <Nav.Item icon={Settings} to={`/team/settings`} title="Edit team settings">Settings</Nav.Item>
    <Nav.Item icon={UserPlus} to={`/team/members`} title="Manage team members">Members</Nav.Item>
    <Nav.Item icon={Box} to={`/team/subscriptions`} title="Manage subscriptions">Subscriptions</Nav.Item>
    <Nav.Item icon={CreditCard} to={`/team/payment`} title="Manage billing information">Payment</Nav.Item>
    <Nav.Item icon={File} to={`/team/invoices`} title="View invoices">Invoices</Nav.Item>
  </Nav>
}